














































import Vue from "vue";
import { NavigationItem } from "@/commons/types";

export default Vue.extend({
  data() {
    return {
      navigationItems: [
        {
          title: "Home",
          icon: "mdi-home-outline",
          name: "Home",
          disabled: false,
        },
        {
          title: "Analytics",
          icon: "mdi-google-analytics",
          name: "Analytics",
          disabled: false,
        },
        {
          title: "Adunit Group",
          icon: "mdi-group",
          name: "AdunitGroup",
          disabled: false,
        },
        {
          title: "Wrapper",
          icon: "mdi-xml",
          name: "Wrapper",
          disabled: true,
        },
        {
          title: "ID Manager",
          icon: "mdi-link-variant",
          name: "IdManager",
          disabled: true,
        },
        {
          title: "Engagement",
          icon: "mdi-cached",
          name: "Engagement",
          disabled: true,
        },
        {
          title: "Layout",
          icon: "mdi-brain",
          name: "Layout",
          disabled: true,
        },
        {
          title: "Core Web Vitals",
          icon: "mdi-chart-bar-stacked",
          name: "CoreWebVitals",
          disabled: false,
        },
        {
          title: "Release Note",
          icon: "mdi-bell-alert",
          name: "ReleaseNote",
          disabled: false,
        },
        {
          title: "Help Center",
          icon: "mdi-help-circle-outline",
          name: "Help",
          disabled: false,
        },
        {
          title: "Setting",
          icon: "mdi-cog-outline",
          name: "Setting",
          disabled: false,
        },
      ] as NavigationItem[],
      toggleDrawer: true as boolean, // true: show, false: hide
      companyLink: "https://flux-g.com/",
      privacyPolicyLink: "https://flux.jp/devicepolicy/",
    };
  },
  computed: {
    isMobileDisplay(): boolean {
      return this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "sm";
    },
  },
  created() {
    // タブレット・モバイルはサイドバーをデフォルト非表示
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
      case "md":
        this.toggleDrawer = false;
    }
  },
  methods: {
    toggle() {
      this.toggleDrawer = !this.toggleDrawer;
    },
  },
});
